import { useStateStore } from '../../stores/useStateStore';

const DEFAULT_CHAT_APPLICATION_ID = 1;

export const useChatApplicationID = (): number => {
  const user_application_id = useStateStore(
    (state) => state.current_user?.chatApplicationId
  );

  if (user_application_id) {
    return parseInt(user_application_id);
  }

  return DEFAULT_CHAT_APPLICATION_ID;
};
